import React from 'react'
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import lottery from '../Assests/lottery.jpg'
import { useNavigate } from 'react-router-dom';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import reportJpg from '../Assests/Report.jpg'

function ReportMain() {
    const navigate = useNavigate();

  return (
    <div style={{ position: 'relative', minHeight: '100vh' }}>

    {/* Back button in the top-left corner */}
    <button
      style={{
        position: 'absolute',
        top: '40px',
        left: '40px',
        border: 'none',
        cursor: 'pointer',
        fontSize: '40px',
        background: 'none',
      }}
      onClick={() => navigate(-1)}
    >
      <ArrowCircleLeftIcon style={{ fontSize: '50px' }} />
    </button>

    {/* Cards layout */}
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'black',
        fontWeight: 'bold',
        fontSize: 40,
        gap: '50px',
        minHeight: '100vh',
      }}
    >
      <Card
        sx={{
          width: '90%',
          maxWidth: '350px',
          height: 'auto',
          maxHeight: '60vh',
          minWidth: '200px',
          margin: '10px',
        }}
      >
        <CardActionArea onClick={() => navigate('/Reports')}>
          <CardMedia
            component="img"
            height="200"
            image={reportJpg}
            alt="dealers"
          />

          <CardContent>
            <Typography
              gutterBottom
              variant="h5"
              component="div"
              sx={{ textAlign: 'center', fontWeight: 'bold' }}
            >
              DASHBOARD
            </Typography>
          </CardContent>
        </CardActionArea>
        <CardActions>
          <button class="cta" onClick={() => navigate('/Reports')}>
            <span>Click Here</span>
            <svg width="15px" height="10px" viewBox="0 0 13 10">
              <path d="M1,5 L11,5"></path>
              <polyline points="8 1 12 5 8 9"></polyline>
            </svg>
          </button>
        </CardActions>
      </Card>

      <Card
        sx={{
          width: '90%',
          maxWidth: '350px',
          height: 'auto',
          maxHeight: '60vh',
          minWidth: '200px',
          margin: '10px',
        }}
      >
        <CardActionArea onClick={() => navigate('/lotteryStock')}>
          <CardMedia
            component="img"
            height="200"
            image={reportJpg}
            alt="dealers"
          />

          <CardContent>
            <Typography
              gutterBottom
              variant="h5"
              component="div"
              sx={{ textAlign: 'center', fontWeight: 'bold' }}
            >
              STOCK REPORTS
            </Typography>
          </CardContent>
        </CardActionArea>
        <CardActions>
          <button class="cta" onClick={() => navigate('/lotteryStock')}>
            <span>Click Here</span>
            <svg width="15px" height="10px" viewBox="0 0 13 10">
              <path d="M1,5 L11,5"></path>
              <polyline points="8 1 12 5 8 9"></polyline>
            </svg>
          </button>
        </CardActions>
      </Card>

      <Card
        sx={{
          width: '90%',
          maxWidth: '350px',
          height: 'auto',
          maxHeight: '60vh',
          minWidth: '200px',
          margin: '10px',
        }}
      >
        <CardActionArea onClick={() => navigate('/salesReport')}>
          <CardMedia component="img" height="200" image={reportJpg} alt="lottery" />

          <CardContent>
            <Typography
              gutterBottom
              variant="h5"
              component="div"
              sx={{ textAlign: 'center', fontWeight: 'bold' }}
            >
              GENARAL REPORTS
            </Typography>
          </CardContent>
        </CardActionArea>
        <CardActions>
          <button class="cta" onClick={() => navigate('/salesReport')}>
            <span>Click Here</span>
            <svg width="15px" height="10px" viewBox="0 0 13 10">
              <path d="M1,5 L11,5"></path>
              <polyline points="8 1 12 5 8 9"></polyline>
            </svg>
          </button>
        </CardActions>
      </Card>
      
    </div>
  </div>
  )
}

export default ReportMain